<template>
  <section>
    <qx-search-box
        class="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        :moreSearchVisible="true"
        permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import { Message } from 'element-ui';
// import {
//   getEnumList,
// } from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        goodsStatusOptions: [], // 货源状态
        form: [
          { // 订单号
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
          },
          { // 订单状态
            label: '订单状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择订单状态',
            default: -1,
            options: [
              {label: '全部', value: -1},
              {label: '运输中', value: 0},
              {label: '运输完成', value: 1},
            ],
          },
          { // 司机名称
            label: '司机名称',
            value: 'driverName',
            type: 'input',
            placeholder: '请输入司机名称',
          },
          { // 司机账号
            label: '司机账号',
            value: 'driverPhone',
            type: 'input',
            placeholder: '请输入司机账号',
          },
          { // 车牌号
            label: '车牌号',
            value: 'plateNUmber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          { // 客户名称
            label: '客户名称',
            value: 'customerName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 线路名称
            label: '线路名称',
            value: 'lineName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 装货磅单号
            label: '装货磅单号',
            value: 'weightNumber',
            type: 'input',
            placeholder: '请输入装货磅单号',
          },
          { // 装货时间
            label: '装货时间',
            value: 'loadingTime',
            type: 'date',
            placeholder: '请选择装货时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 卸货时间
            label: '卸货时间',
            value: 'unloadTime',
            type: 'date',
            placeholder: '请选择卸货时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '数据状态',
            value: 'dataState',
            type: 'checkbox',
            options: [
              {label: '待匹配', value: 0},
              {label: '待核准', value: 1},
              {label: '无需确认', value: 2},
            ],
          },
          {
            label: '数据来源',
            value: 'orderSource',
            type: 'checkbox',
            options: [
              {label: '司机', value: 0},
              {label: 'pc导入', value: 1},
            ],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.dataState && searchBoxData.orderSource && (searchBoxData.dataState.indexOf(1) > -1 || searchBoxData.dataState.indexOf(2) > -1) &&
      ((searchBoxData.orderSource.indexOf(0) > -1 && searchBoxData.orderSource.indexOf(1) <= -1) ||
          (searchBoxData.orderSource.indexOf(1) > -1 && searchBoxData.orderSource.indexOf(0) <= -1))) {
        Message({
          message: '待核准和无需确认的数据状态数据只存在数据源两个都选择的情况！',
          type: 'info',
        });
        return;
      }
      // 装货时间
      if (searchBoxData.loadingTime && searchBoxData.loadingTime.length > 0) {
        searchBoxData.loadingTimeStart = this.formatDate(searchBoxData.loadingTime[0]);
        searchBoxData.loadingTimeEnd = this.formatDate(searchBoxData.loadingTime[1]);
        delete searchBoxData.loadingTime;
      }
      // 卸货时间
      if (searchBoxData.unloadTime && searchBoxData.unloadTime.length > 0) {
        searchBoxData.unloadTimeStart = this.formatDate(searchBoxData.unloadTime[0]);
        searchBoxData.unloadTimeEnd = this.formatDate(searchBoxData.unloadTime[1]);
        delete searchBoxData.unloadTime;
      }
      this.$refs.tableBox.saveSearchBoxData({...searchBoxData});
    },
  },
  async created () {
    // const enumsList = await getEnumList({
    //   codeType: 'GOODS_STATE'
    // });
    // this.searchBoxData.goodsStatusOptions = [ // 货源状态
    //   {
    //     label: '全部',
    //     value: -1,
    //   },
    //   ...enumsList[0],
    // ];
  },
};
</script>

<style lang="scss" scoped>
</style>
